import { render, staticRenderFns } from "./FlipkartSummary.vue?vue&type=template&id=584bd406&scoped=true&lang=pug"
import script from "./FlipkartSummary.js?vue&type=script&lang=js&external"
export * from "./FlipkartSummary.js?vue&type=script&lang=js&external"
import style0 from "./FlipkartSummary.vue?vue&type=style&index=0&id=584bd406&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584bd406",
  null
  
)

export default component.exports